<template>
  <div class="card">
    <HseHeading size="h3">{{ data.ReportTitle }}</HseHeading>
    <HseSpace size="small" vertical />
    <ReadonlyInput :label="$t('number')" :value="data.numberRequest" />
    <ReadonlyInput :label="$t('event')" :value="data.Title" />
    <ReadonlyInput :label="$t('format')" :value="data.ReportExist" />
    <div class="two-cols">
      <ReadonlyInput
        :isActive="
          (data.improvementStatus || data.FinalScore !== null) &&
          (data.Status === 'Оценена' || data.Status === 'Rated') &&
          data.participation === null
        "
        :label="$t('requestStatus')"
        :value="data.Status"
      />
      <ReadonlyInput
        v-if="data.payment_status_int !== -2"
        :label="$t('paymentStatus')"
        :value="paymentStatus"
      />
    </div>
    <div class="two-cols">
      <ReadonlyInput
        v-if="data.FinalScore"
        :isActive="
          data.FinalScore !== null &&
          (data.Status === 'Оценена' || data.Status === 'Rated') &&
          data.participation === null
        "
        :label="$t('reviewStatus')"
        :value="data.FinalScore"
      />
      <ReadonlyInputWithTooltip
        v-if="data.payment_status_int === -2"
        :tooltipText="$t('infoPaymentDisabled')"
        :label="$t('paymentStatus')"
        :value="paymentStatus"
      />
    </div>
    <div class="actions">
      <div v-if="isCollectiveReq">
        <HseSpace size="small" vertical />
        <HseButton
          class="collectiveBtn"
          size="medium"
          v-on:click="confirmParticipation"
          >{{ $t("collectiveReq") }}</HseButton
        >
        <HseSpace size="small" vertical />
      </div>
      <div>
        <div v-if="isShowCertificate" class="divCertificate">
          <a
            class="link"
            :href="`/files/download_certificate?request=${data.Id}&lang=ru`"
            >{{ $t("certificateRu") }}</a
          >
          <a
            class="link"
            :href="`/files/download_certificate?request=${data.Id}&lang=en`"
            >{{ $t("certificateEn") }}</a
          >
        </div>
        <a class="link" :href="`/#/requests/${data.Id}`">{{ $t("open") }}</a>
        <div v-if="(data.Status === 'Оценена' && data.FinalScore === 'Принять') || (data.Status === 'Rated' && data.FinalScore === 'Accept') ">
          <br />
          <a class="link" :href="`/#/requests/${data.Id}?openCommitModal=true`">{{ $t("confirmAndUpload") }}</a>
        </div>
       
        <br />
        <a
          v-if="isEditReq"
          class="link"
          :href="`/#/requests/update/${data.Id}`"
          >{{ $t("update") }}</a
        >
      </div>
      <div>
        <!-- :href="`/#/requests/${data.Id}/payment`" -->
        <a
          v-if="
            isPaymentEnabled &&
            (
              (
                (data.ReportExist === 'без доклада' || data.ReportExist === 'Without a report') &&
                (data.Status === 'Принята' || data.Status === 'Accepted')
              ) ||
              (
                (data.ReportExist === 'с докладом' || data.ReportExist === 'Speaker') &&
                (data.Status === 'Оценена' || data.Status === 'Rated') &&
                (data.FinalScore === 'Принять' || data.FinalScore === 'Accept')
              )
            )"
          class="link boldLink"
          v-on:mouseup="() => ClickPayment(this.data.Id)"
          >{{ $t("payment") }}</a
        >
        <br
          v-if="
            data.ReportExist !== 'без доклада' &&
            data.ReportExist !== 'Without a report' &&
            data.collectiveRequestId &&
            isPaymentEnabled
          "
        />
        <a
          v-if="
            data.ReportExist !== 'без доклада' &&
            data.ReportExist !== 'Without a report' &&
            data.collectiveRequestId
          "
          class="link"
          :href="`/#/collective-requests/${data.collectiveRequestId}`"
          >{{ $t("collectiveReqOpen") }}</a
        >
        <br />
        <span
          v-show="
            data.currentCoAuthor === true &&
            data.coAuthorPassportId === null &&
            IsRequiredPassport
          "
          class="link"
          v-on:mouseup="() => ClickAddPassport(data.Id, data.EventId)"
          >{{ $t("pd") }}</span
        >
      </div>
    </div>
    <HseModal v-model="modalPassport" :shouldCloseOnOverlayClick="false">
      <ModalPassport @closeModal="closeModalPassport" :fields="fields" />
    </HseModal>
    <HseModal
      v-model="modalConfirmParticipationIsOpen"
      :shouldCloseOnOverlayClick="false"
    >
      <ModalConfirmParticipation
        :confirmationStatus="confirmationStatus"
        :confirmationMessage="confirmationMessage"
        :spinner="buttonSpinner"
        :field="codeFromEmail"
        :collectiveRequestDirection="collectiveRequestDirection"
        :requestId="requestId"
        @closeModal="closeModalParticipation"
        @getBackIfErr="getBackIfErr"
        @approveMember="approveMember"
      />
    </HseModal>

     <HseModal v-model="isModalOpenCode">
      <div class="hasCodeQuestion">
        <HseSpace  vertical horizontal :size="'medium'"/>

        <template v-if="!hasCode">
                  <HseHeading size="h3">{{ $t('havePromocode') }}</HseHeading>
                  <HseSpace  vertical horizontal :size="'medium'"/>

                <div class="hasCode">
                  <HseButton @click="ClickHasCode" size='medium'>
                    {{ $t('yes') }}
                  </HseButton>
                  <HseSpace  vertical horizontal :size="'medium'"/>
                  <HseButton @click="ClickNoCode(data.Id)" variant='secondary' size='medium'>
                    {{ $t('no') }}
                  </HseButton>
                </div>
        </template>
        <template v-else-if="buttonSpinnerCode !== 'done'">
          <HseHeading size="h3">{{ $t('enterPromocode') }}</HseHeading>
          <HseSpace  vertical horizontal :size="'medium'"/>
          <HseTooltip :content="$t('codeTooltip')">
            <div class="promocode">
              
              <HseRichInput v-model="promocode" :placeholder="$t('yourPromocode')" error="" :error-message="errorMessagePromocode"/>
               
             
              <HseSpace  vertical horizontal :size="'medium'"/>

              <HseButton :spinner="buttonSpinnerCode" spinnerPosition="left" @click="checkPaymentCode" :disabled="!promocode">
                <span v-if="buttonSpinnerCode === true">{{ $t("checking") }}</span>
                <span v-else-if="buttonSpinnerCode === false">{{
                  $t("checkCode")
                }}</span>
              </HseButton>
              <HseSpace size="small_2x" vertical />
            </div>
          </HseTooltip>
        </template>
        <div v-else-if="buttonSpinnerCode === 'done'" class="doneMessagePromocode">
          <svg width="110" height="100" viewBox="0 0 110 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M26.8055 8.42652C35.0279 2.93245 44.6949 0 54.584 0C67.8448 0 80.5625 5.26784 89.9393 14.6447C99.3161 24.0215 104.584 36.7392 104.584 50C104.584 59.8891 101.652 69.556 96.1575 77.7785C90.6634 86.0009 82.8545 92.4096 73.7182 96.194C64.5819 99.9783 54.5285 100.969 44.8295 99.0392C35.1304 97.11 26.2213 92.3479 19.2287 85.3553C12.236 78.3627 7.474 69.4535 5.54474 59.7545C3.61548 50.0555 4.60565 40.0021 8.39003 30.8658C12.1744 21.7295 18.583 13.9206 26.8055 8.42652ZM85.4219 35.1375L79.2732 28.9887L46.4721 61.7897L29.8964 45.214L23.7476 51.3627L46.4721 74.0872L85.4219 35.1375Z"
              fill="#0050CF" />
          </svg>
            <HseSpace size="large" vertical />
            <HseHeading size="h3">{{ $t('codeDone') }}</HseHeading>
            <HseSpace size="medium" vertical />
            <HseButton @click="() => isModalOpenCode = false ">{{ $t('close') }}</HseButton>
        </div>
      </div>
    </HseModal>
    
  </div>
</template>

<script>
import ReadonlyInput from "../common/ReadonlyInput.vue";
import ReadonlyInputWithTooltip from "../common/ReadonlyInputWithTooltip.vue";
import {
  HseHeading,
  HseSpace,
  HseInput,
  HseButton,
  HseModal,
  HseRichInput,
  HseTooltip,
} from "@hse-design/vue";
import ModalConfirmParticipation from "./ModalConfirmParticipation.vue";
import ModalPassport from "./ModalPassport.vue";
import { mapState } from "vuex";
import { api } from "../../api";
import fields from "./passportFields";
import { localizeFields } from "../../i18n";
import { store } from "../../store";
export default {
  store,
  name: "eventCard",
  components: {
    ReadonlyInput,
    ReadonlyInputWithTooltip,
    HseHeading,
    HseButton,
    HseSpace,
    HseModal,
    ModalConfirmParticipation,
    ModalPassport,
    HseRichInput,
    HseTooltip
  },
  data: () => ({
    fields,
    IsRequiredPassport: false,
    requestIdWithAppPassport: "",
    eventIdWithAppPassport: "",
    modalPassport: false,
    isModalOpenCode: false,
    hasCode: false,
    modalConfirmParticipationIsOpen: false,
    confirmationStatus: false,
    confirmationMessage: "",
    buttonSpinner: false,
    isMatch: false,
    buttonSpinnerCode: false,
    errorMessagePromocode: "",
    collectiveRequestDirection: "",
    requestId: "",
    promocode: "",
    field: {
      isCode: true,
      isValid: false,
      isRequired: true,
      label: "",
      value: null,
      // component: HseInput,
    },
    showPaymentExemptionCode: false,
  }),
  props: ["data", "changeType", "type", "allData"],
  created() {
    this.field.label = this.$t("code");
    this.translateFields();
     this.checkPaymentStatusByEvent();    
    api
      .request("get_citizen", { UserId: this.$store.state.user.id })
      .then((data) => {
        this.citizen = data.Citizen

        setTimeout(() => {
          api
            .request("get_is_required_passport", { EventId: this.eventId })
            .then((data) => {

              const citizenIdRussia = 'BC763F4B-FBD9-461B-B395-166020E8C026' // Российская Федерация

              if (
                  ( data.IsRequiredPassport && data.IsRequiredPassportRussia && this.citizenId === citizenIdRussia ) ||
                  ( data.IsRequiredPassport && data.IsRequiredPassportOther && this.citizenId !== citizenIdRussia )
              ) { this.IsRequiredPassport = true }
            });
        }, 0)
      })
  }, 
  updated() {
    this.field.label = this.$t("code");
  },
  watch: {
    isModalOpenCode(newValue) {
      if (!newValue) {
        this.hasCode = false;
        this.promocode = "";
        this.buttonSpinnerCode = false
        this.errorMessagePromocode = ""
        this.doneMessagePromocode = ""
      }
    },
    promocode(newValue) {
      if (newValue) {
        this.errorMessagePromocode = ""
      }
    }
  },
  methods: {
    translateFields() {
      this.fields = localizeFields(fields, this.fields);
    },
    getBackIfErr() {
      this.confirmationStatus = false;
    },
    setField(isValid, value = "") {
      this.field.value = value;
      this.field.isValid = isValid;
    },
    confirmParticipation() {
      this.modalConfirmParticipationIsOpen = true;
    },
    approveMember() {
      const params = {
        code: this.code,
        requestId: this.data.Id,
        requestAutoNum: this.data.numberRequest,
        eventId: this.data.EventId,
      };
      this.buttonSpinner = true;
      api.request("collective_request_approve", params).then((res) => {
        this.buttonSpinner = "done";

        setTimeout(() => {
          this.buttonSpinner = false;
          if (
            res.collectiveRequestId ||
            (Array.isArray(res) &&
              typeof res[0].collectiveRequestId === "string")
          ) {
            this.confirmationStatus = true;
          } else if (
            res.message === "Код подтверждения от другого мероприятия"
          ) {
            this.confirmationStatus = "error";
            this.confirmationMessage = res.message;
          } else {
            this.confirmationStatus = "error";
            this.confirmationMessage = "";
          }
        }, 2000);
      });
    },
    closeModalParticipation(isSend) {
      if (isSend === true) {
        if (this.code === "" || this.code === null) {
          this.field.isValid === false;
          return;
        } else {
          this.field.isValid === true;
        }
        const paramsRequestCheckDirection = {
          code: this.code,
          requestId: this.data.Id,
          eventId: this.data.EventId,
        };
        api
          .request(
            "collective_request_check_direction",
            paramsRequestCheckDirection
          )
          .then((res) => {
            if (res.message === "Error: Wrong confirmation code") {
              this.confirmationStatus = "error";
              this.confirmationMessage = "";
            } else if (
              res.message === "Error: Код подтверждения от другого мероприятия"
            ) {
              this.confirmationStatus = "error";
              this.confirmationMessage = res.message;
            } else if (!res.match) {
              this.confirmationStatus = "without direction";
              this.collectiveRequestDirection = res.collectiveRequestDirection;
              this.requestId = this.data.Id;
            }
            if (res.match) {
              this.approveMember();
            }
          });
      } else if (isSend === "done") {
        this.changeType(this.type.id);
        this.modalConfirmParticipationIsOpen = false;
        this.confirmationStatus = false;
      } else {
        this.modalConfirmParticipationIsOpen = false;
      }
    },
    ClickAddPassport(requestId, eventId) {
      this.requestIdWithAppPassport = requestId;
      this.eventIdWithAppPassport = eventId;
      this.modalPassport = true;
    },
      ClickPayment(id) {
      if (this.showPaymentExemptionCode && !this.isStudying) {
        this.$router.push(`/requests/${id}/payment`)
      } else {
        this.isModalOpenCode = true
      }
    },
     ClickHasCode() {
      this.hasCode = true
    },
    ClickNoCode(id) {
      this.$router.push(`/requests/${id}/payment`)
    },
    checkPaymentCode() {
      this.buttonSpinnerCode = true;
      const params = {
        EventId: this.data.EventId,
        Code: this.promocode,
        RequestId: this.data.Id,
        ApplicantEmail: store.state.user.login
      };
      api.request("payments_check_exemption_code", params).then((response) => {

        if (response === true) {
          this.buttonSpinnerCode = 'done';
          this.$emit('update-requests-list')
        } else {
          this.errorMessagePromocode = this.$t("errorMessagePromocode");
          this.buttonSpinnerCode = false;
      
        }
      });
    },
    
    checkPaymentStatusByEvent() {
      this.buttonSpinner = true;
      const params = {
        EventId: this.eventId,
      };
      api.request("payment_status_by_event", params).then((response) => {
        if (response === 0 || response === false) {
          this.showPaymentExemptionCode = true;
        }
      });
      this.buttonSpinner = false;
    },
    closeModalPassport(isSend) {
      if (isSend === true) {
        const params = {};
        params.UserId = store.state.user.id;
        // params.RequestIdList = [];
        params.PassportId = this.fields.Passport.value;
        params.RequestIdList = this.allData
          .filter(
            (item) =>
              item.EventId === this.eventIdWithAppPassport &&
              item.currentCoAuthor &&
              item.coAuthorPassportId === null
          )
          .map((item) => item.Id);
        api.request("add_passport_id_for_co_author", params).then(() => {
          this.changeType(this.type.id);
        });
        const paramsPassport = {
          EventId: this.eventIdWithAppPassport,
          Email: store.state.user.login,
          PassportId: this.fields.Passport.value,
        };
        api.request("add_passport", paramsPassport).then((data) => {
          console.log("data requestAdd", data);
          this.modalPassport = false;
        });
      } else {
        this.modalPassport = false;
      }
    },
  },
  computed: {
      codeFromEmail () {
        return {
          value: null,
          isValid: false,
          label:  this.$t("code"),
          isRequired: true,
          size: 'large',
          component: HseInput,
          setValues: (isValid, value = '') => {
            console.log(isValid, value, 'setField');
            this.field.value = value;
            this.field.isValid = isValid;
          }
        }
      },
     isStudying() {
        return this.data.OccupationType.value === "2";
      },
    isEditReq() {
      const endReportDateTimeStamp = new Date(
        this.data.endReportDate
      ).getTime();
      const endRequesDateTimeStamp = new Date(
        this.data.EndRequestDate
      ).getTime();
      const currentDate = new Date().getTime() + 3 * 60 * 60 * 1000;
      const data =
        this.data.ReportExist === "с докладом" ||
        this.data.ReportExist === "Speaker"
          ? currentDate < endReportDateTimeStamp
          : currentDate < endRequesDateTimeStamp;
      return (
        data &&
        this.data.Status !== "Отменена заявителем" &&
        this.data.Status !== "Cancelled by user" &&
        this.data.Status !== "Отклонена" &&
        this.data.Status !== "Rejected"
        // this.data.Status !== "Требуется доработка" &&
        // this.data.Status !== "Sent for rework"
      );
    },
    isCollectiveReq() {
      return (
        this.data.Status !== "Отменена заявителем" &&
        this.data.Status !== "Cancelled by user" &&
        this.data.ReportExist !== "без доклада" &&
        this.data.ReportExist !== "Without a report" &&
        this.data.inviteToCollectiveRequests &&
        !this.data.confirmToCollectiveRequests &&
        !this.data.coAuthor && 
        this.data.IsSpeaker
      );
    },
    code() {
      return this.field.value;
    },
    isShowCertificate() {
    // 1. Проверка типа страницы
    if (this.$route.query.type !== "archive") return false;

    const reportExistLower = this.data.ReportExist?.toLowerCase() || '';
    const statusLower = this.data.Status?.toLowerCase() || '';

    // 2. Проверка комбинации ReportExist + Status
    const isValidCombination = (
        ((reportExistLower === 'speaker' || reportExistLower.includes('с докладом')) &&
         (statusLower === 'rated' || statusLower.includes('оценена'))) ||
        ((reportExistLower === 'without a report' || reportExistLower.includes('без доклада')) &&
         (statusLower === 'rated' || statusLower.includes('принята')))
    );
    if (!isValidCombination) return false;

    // 3. Проверка оплаты
    if (!(this.isNotPayed || this.isPayed)) return false;

    // 4. Проверка представления доклада
    if (this.data.ReportExistsInt && !this.data.ReportPresented) return false;

    return true;
    },
    isPaymentEnabled() {
      return this.data.payment_status_int == 0;
    },
    isNotPayed() {
      return this.data.payment_status_int === -1;
    },
    isPayed() {
      return this.data.payment_status_int === 1;
    },
    isCertEnabled() {
      return (
        this.data.payment_status_int == -1 || this.data.payment_status_int == 1
      );
    },
    isRuFile() {
      return this.data.ThesesFileID !== null && this.lang === "ru";
    },
    isEnFile() {
      return this.data.ThesesFileEnID !== null;
    },
    paymentStatus() {
      switch (this.data.payment_status_int) {
        case -2:
          return this.$i18n.t("PaymentDisabled");
        case -1:
          return this.$i18n.t("PaymentNotNeeded");
        case 1:
          return this.$i18n.t("payed");
        case 0:
          return this.$i18n.t("notPayed");
        default:
          return "";
      }
    },
    ...mapState(["lang"]),
  },
  i18n: {
    messages: {
      en: {
        payment: "Payment",
        event: "Event",
        number: "Request number",
        format: "Form of participation",
        requestStatus: "Request status",
        reviewStatus: "Review status",
        paymentStatus: "Payment status",
        open: "View request",
        collectiveReqOpen: "Collective request",
        update: "Editing request",
        certificateRu: "Download certificate(ru)",
        certificateEn: "Download certificate(en)",
        notPayed: "Not payed",
        payed: "Payed",
        paymentProcess: "In payment process",
        PaymentNotNeeded: "Payment not needed",
        PaymentDisabled: "Payment disabled",
        PaymentHint:
          "Payment is possible after your paper is validated and approved",
        infoPaymentDisabled:
          "Payment for participation is possible after reviewing the report and including it in the conference program",
        collectiveReq: "Confirm participation in the collective session",
        code: "Code from the letter",
        pd: "Attach a copy of your passport",
        yes: "Yes",
        no: "No",
        checkCode: "Apply",
        checking: "Checking the code",
        codeDone: "Code applied",
        codeTooltip: "Enter the code provided by Organizing Committee",
        enterPromocode: "Please enter your promocode",
        yourPromocode: "Your promocode",
        havePromocode: "Do you have a promocode?",
        errorMessagePromocode: "The promocode you have entered is invalid",
        close: "Close",
        confirmAndUpload: "Confirm participation and upload presentation",
      },
      ru: {
        payment: "Оплата",
        event: "Мероприятие",
        number: "Номер заявки",
        format: "Формат участия",
        requestStatus: "Статус заявки",
        reviewStatus: "Статус рассмотрения",
        paymentStatus: "Статус оплаты",
        open: "Просмотр",
        confirmAndUpload: "Подтвердить участие и загрузить презентацию",
        collectiveReqOpen: "Коллективная заявка",
        update: "Редактирование заявки",
        certificateRu: "Скачать сертификат(рус.)",
        certificateEn: "Скачать сертификат(англ.)",
        notPayed: "Не оплачена",
        payed: "Оплачена",
        paymentProcess: "В процессе оплаты",
        PaymentNotNeeded: "Оплата не требуется",
        PaymentDisabled: "Оплата недоступна",
        PaymentHint:
          "Оплата участия возможна после рассмотрения доклада и включения его в программу конференции",
        infoPaymentDisabled:
          "Оплата участия возможна после рассмотрения доклада и включения его в программу конференции",
        collectiveReq: "Подтвердить участие в коллективной сессии",
        code: "Код из письма",
        pd: "Прикрепить копию паспорта ",
        yes: "Да",
        no: "Нет",
        checkCode: "Применить",
        checking: "Проверяем код",
        codeDone: "Код применен",
        codeTooltip: "Введите код, предоставленный оргкомитетом",
        enterPromocode: "Введите промокод",
        yourPromocode: "Ваш промокод",
        havePromocode: "У вас есть промокод?",
        errorMessagePromocode: "Промокод не действителен",
        close: "Закрыть",
      },
    },
  },
};
</script>

<style scoped>

.doneMessagePromocode {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.promocode {
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
.hasCode {
  display: flex;
  align-items: center;
  justify-content: center;
}
.hasCodeQuestion {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 20px;
}
.link {
  font-size: 80%;
  cursor: pointer;
  color: blue;
}
.two-cols {
  display: flex;
  margin: 0 -15px;
}
.two-cols > div {
  padding: 0 15px;
  flex: 1;
}
.link {
  white-space: nowrap;
  font-weight: 600;
   white-space: normal;
  font-size: 14px;
  line-height: 20px;
}
.boldLink {
  font-weight: 900;
  display: inline-block;
}
.actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 0 -15px;
}
.actions > * {
  margin: 0 15px;
}
.actions .link {
  padding: 5px 0;
}
.collectiveBtn {
  width: fit-content;
}
.divCertificate {
  display: flex;
  flex-direction: column;
}

@media (max-width: 767px) {
  .two-cols,
  .actions {
    flex-direction: column;
  }
  .two-cols > div {
    width: 100%;
  }
  .actions {
    align-items: flex-start;
    justify-content: flex-start;
  }
  .promocode {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
</style>
<style>
.hse-TooltipTarget {
  width: 100%;
}
</style>
